import { motion } from "framer-motion";

export default function KPICard({ label, value, sub, icon: Icon, accent = "text-slate-900", index = 0, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06 }}
      data-testid={testId}
      className="bg-white border border-slate-200 rounded-sm p-5 sm:p-6 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md hover:border-slate-300 group"
    >
      <div className="flex items-start justify-between">
        <div className="label-tracking">{label}</div>
        {Icon && <Icon size={18} className="text-slate-400 group-hover:text-slate-700 transition-colors" />}
      </div>
      <div className={`font-display text-4xl sm:text-5xl font-medium leading-none mt-4 ${accent}`}>
        {value}
      </div>
      {sub && <div className="text-xs text-slate-500 mt-3">{sub}</div>}
    </motion.div>
  );
}
